<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'

export default {
  setup(props, context) {
    const designStore = useDesignStore()

    return {
      designStore,
      props
    }
  },
  components: {}
}
</script>

<template>
  <div class="genericGridDisplayContainer">
    <slot></slot>
  </div>
</template>

<style>
.genericGridDisplay {
  border: 3px solid;
  border-radius: 0.375rem;
  padding: 1rem;
  align-items: center;
  margin: 2rem;
}

.genericGridDisplayContainer {
  column-count: 2;
}

@media (min-width: 1900px) {
  .genericGridDisplayContainer {
    column-count: 3;
  }
}

@media (max-width: 900px) {
  .genericGridDisplayContainer {
    column-count: 1;
  }
}
</style>
